import { ChangeDetectorRef, Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faSearch,
  faTh,
  faTachometerAlt,
  faChartLine,
  faAngleLeft,
  faAngleRight,
  faStepBackward,
  faStepForward,
  faCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
// import * as Highcharts from 'highcharts';
declare var $: any;

@Component({
  selector: 'app-dashboard-execution',
  templateUrl: './dashboard-execution.component.html',
  styleUrls: ['./dashboard-execution.component.scss'],
})
export class DashboardExecutionComponent implements OnInit {
  faTh = faTh;
  faTachometerAlt = faTachometerAlt;
  faChartLine = faChartLine;
  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faFileExport = faFileExport;
  faCircle = faCircle;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;

  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private Config: Config,
    private appService: AppService,
    private _cdr: ChangeDetectorRef,
    private pagerService: PagerService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

  }

  modelData: any;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };


  /// app open
  eutCollection: any = { TF: [], UR: [], BF: [], XX: [] };
  listOfEUTs: any;
  scenarios: any;
  runInfo: any;
  /// app close

  /// model open
  model: any = {
    startAt: 0,
    eutType: 'TF',
    db: 'testExecutionQuality',
    maxColumns: 15,
    maxRows: 10,
    listLength: 10,
    dashboards: {},
    dashboardsUI: {},
    attributes: [],
    deSelectCollection: {},
  };

  /// model close

  /// controller open
  disableDown: any;
  disableUp: any;
  // dependencyWheelChart: any = '';
  /// controller close

  dashBoardName: any = 'Execution Dashboard';
  eutType: any = '';
  startAt = 0;

  ngOnInit(): void {
    console.log('db init');
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });

    setTimeout(() => {
      this.getVideoURL('testExecutionQuality')
    }, 2000);
    this.modelData = this._sharedService.loadedProjectData.model;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.scenarios = this.modelData.scenarios;
    this.runInfo = this.modelData.runInfo;
    this.eutCollection['TF'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.eutCollection['UR'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.eutCollection['BF'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );
    this.eutCollection['XX'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'XX'
    );
    this.allItems = this.eutCollection['TF'];
    this.setPage(1);

    //// model load

    this.model.dashboards = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [], XX: [] },
    };

    this.model.dashboardsUI = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [], XX: [] },
    };

    this.model.totalOfDashboardUI = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [] },
    };
    this.model.deSelectCollection = { TF: [], UR: [], BF: [], XX: [] };
    this.model.attributes = this.Config.listOfAttributesDB;
    this.loadDashboards();
    this.loadDashboardsUI();
    this.isUpDownValid();
    this.reloadToolService.triggerSmartChecklist('');
    // this.dependencyChart();
  }
  // dependencyChart(){
  //   this.dependencyWheelChart = new Highcharts.Chart('dependencyWheelCharts', {

  //     title: {
  //         text: 'Highcharts Dependency Wheel'
  //     },
  
  //     accessibility: {
  //         point: {
  //             valueDescriptionFormat: '{index}. From {point.from} to {point.to}: {point.weight}.'
  //         }
  //     },
  
  //     series: [{
  //         keys: ['from', 'to', 'weight'],
  //         data: [
  //             ['Brazil', 'Portugal', 5],
  //             ['Brazil', 'France', 1],
  //             ['Brazil', 'Spain', 1],
  //             ['Brazil', 'England', 1],
  //             ['Canada', 'Portugal', 1],
  //             ['Canada', 'France', 5],
  //             ['Canada', 'England', 1],
  //             ['Mexico', 'Portugal', 1],
  //             ['Mexico', 'France', 1],
  //             ['Mexico', 'Spain', 5],
  //             ['Mexico', 'England', 1],
  //             ['USA', 'Portugal', 1],
  //             ['USA', 'France', 1],
  //             ['USA', 'Spain', 1],
  //             ['USA', 'England', 5],
  //             ['Portugal', 'Angola', 2],
  //             ['Portugal', 'Senegal', 1],
  //             ['Portugal', 'Morocco', 1],
  //             ['Portugal', 'South Africa', 3],
  //             ['France', 'Angola', 1],
  //             ['France', 'Senegal', 3],
  //             ['France', 'Mali', 3],
  //             ['France', 'Morocco', 3],
  //             ['France', 'South Africa', 1],
  //             ['Spain', 'Senegal', 1],
  //             ['Spain', 'Morocco', 3],
  //             ['Spain', 'South Africa', 1],
  //             ['England', 'Angola', 1],
  //             ['England', 'Senegal', 1],
  //             ['England', 'Morocco', 2],
  //             ['England', 'South Africa', 7],
  //             ['South Africa', 'China', 5],
  //             ['South Africa', 'India', 1],
  //             ['South Africa', 'Japan', 3],
  //             ['Angola', 'China', 5],
  //             ['Angola', 'India', 1],
  //             ['Angola', 'Japan', 3],
  //             ['Senegal', 'China', 5],
  //             ['Senegal', 'India', 1],
  //             ['Senegal', 'Japan', 3],
  //             ['Mali', 'China', 5],
  //             ['Mali', 'India', 1],
  //             ['Mali', 'Japan', 3],
  //             ['Morocco', 'China', 5],
  //             ['Morocco', 'India', 1],
  //             ['Morocco', 'Japan', 3],
  //             ['Japan', 'Brazil', 1]
  //         ],
  //         type: 'dependencywheel',
  //         name: 'Dependency wheel series',
  //         dataLabels: {
  //             color: '#333',
  //             style: {
  //                 textOutline: 'none'
  //             },
  //             textPath: {
  //                 enabled: true
  //             },
  //             distance: 10
  //         },
  //         size: '95%'
  //     }]
  
  // });
  // }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if(this.smartChecklist == false){
      $( ".autoCursor" ).addClass( 'checklistIcon');
      this.smartChecklist = true;
    }else{
      $( ".autoCursor" ).removeClass( 'checklistIcon');
      this.smartChecklist = false;
    }
  }
  setPage(page: number) {
    // get pager object from servicesetPage
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  //// model fn open

  loadDashboards() {
    // console.log('this.model', this.model);

    for (var dashboard in this.model.dashboards) {
      for (var eut in this.model.dashboards[dashboard]) {
        this.model.dashboards[dashboard][eut] = [];
        this.model.attributes.forEach((attribute: any) => {
          var eutList: any = [];
          this.eutCollection[eut].forEach((anEut: any) => {
            var count: any;
            switch (dashboard) {
              case 'testCaseQuality':
                count = this.getScenarioCountForEntity(anEut, attribute.symbol);
                eutList.push({ eID: anEut.eID, count });
                break;
              case 'testExecutionQuality':
                count = this.getScenarioExecutedForEntity(
                  anEut,
                  attribute.symbol
                );
                eutList.push({ eID: anEut.eID, count });
                break;
              case 'cleanlinessDegree':
                count = this.getScenarioPassedForEntity(
                  anEut,
                  attribute.symbol
                );
                eutList.push({ eID: anEut.eID, count });
                break;
              default:
                break;
            }
          });
          var test = this.getTotalForAnAttribute(attribute, dashboard);
          this.model.dashboards[dashboard][eut].push({
            name: attribute,
            eutList,
            test,
          });
        });
      }
    }
    // console.log('this.model1', this.model);
  }

  loadDashboardsUI() {
    for (var dashboard in this.model.dashboardsUI) {
      for (var eut in this.model.dashboardsUI[dashboard]) {
        this.model.dashboardsUI[dashboard][eut] = $.extend(
          true,
          [],
          this.model.dashboards[dashboard][eut]
        );
        this.model.dashboardsUI[dashboard][eut].forEach((attribute: any) => {
          for (
            i = attribute.eutList.length - 1;
            i >= this.model.startAt;
            i -= 1
          ) {
            var idExist = this.model.deSelectCollection[eut].find(
              (id: any) => id == attribute.eutList[i].eID
            );
            if (idExist) {
              attribute.eutList.splice(i, 1);
            }
          }

          attribute.eutList.splice(0, this.model.startAt);
          if (attribute.eutList.length > this.model.maxColumns) {
            attribute.eutList.splice(
              this.model.maxColumns,
              attribute.eutList.length - this.model.maxColumns
            );
          }

          for (
            var i = attribute.eutList.length;
            i < this.model.maxColumns;
            i++
          ) {
            attribute.eutList.push({ count: { total: -1 } });
          }
        });

        //adding rows and columns to match the max rows and columns
        for (
          var i = this.model.dashboardsUI[dashboard][eut].length;
          i < this.model.maxRows;
          i++
        ) {
          var eutList = [];
          for (var j = 0; j < this.model.maxColumns; j++) {
            eutList.push({ count: { total: -1 } });
          }
          this.model.dashboardsUI[dashboard][eut].push({ name: '', eutList });
        }
      }
    }

    for (var dashboard in this.model.totalOfDashboardUI) {
      for (var eut in this.model.totalOfDashboardUI[dashboard]) {
        this.model.totalOfDashboardUI[dashboard][eut] = [];

        var eutListTotal = [];
        for (
          var i = this.model.startAt;
          i < this.eutCollection[eut].length;
          i++
        ) {
          var idExist = this.model.deSelectCollection[eut].find(
            (id: any) => id == this.eutCollection[eut][i].eID
          );
          if (!idExist && eutListTotal.length < this.model.maxColumns) {
            switch (dashboard) {
              case 'testCaseQuality':
                var count = this.getScenarioTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              case 'testExecutionQuality':
                var count = this.getScenarioExecutedTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              case 'cleanlinessDegree':
                var count = this.getScenarioPassedTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              default:
                break;
            }
          }
        }
        for (var j = eutListTotal.length; j < this.model.maxColumns; j++) {
          eutListTotal.push({ count: { total: -1 } });
        }

        eutListTotal.push({ count: { total: 0 } });
        this.model.totalOfDashboardUI[dashboard][eut].push({
          name: '',
          eutListTotal,
        });
        var eutListTotal = [];

        for (
          var i = this.model.startAt;
          i < this.eutCollection[eut].length;
          i++
        ) {
          var idExist = this.model.deSelectCollection[eut].find(
            (id: any) => id == this.eutCollection[eut][i].eID
          );
          if (!idExist && eutListTotal.length < this.model.maxColumns) {
            eutListTotal.push({ count: { total: i + 1 } });
          }
        }
        for (var j = eutListTotal.length; j < this.model.maxColumns; j++) {
          eutListTotal.push({ count: { total: 0 } });
        }
        eutListTotal.push({ count: { total: 0 } });
        this.model.totalOfDashboardUI[dashboard][eut].push({
          name: '',
          eutListTotal,
        });
      }
    }
    // console.log('this.model12', this.model);
  }

  getScenarioTotalForEntity(anEut: any) {
    return this.getScenarioTotalForEntityCheck(anEut.eID);
  }

  getScenarioExecutedTotalForEntity(anEut: any) {
    return this.getScenarioTotalForEntityCheckRunInfo(anEut.eID);
  }

  getScenarioPassedTotalForEntity(anEut: any) {
    return this.getScenarioPassedTotalForEntityRunInfo(anEut.eID);
  }

  getScenarioCountForEntity(anEut: any, attribute: any) {
    return this.getScenarioCountForEntityCheck(anEut.eID, attribute);
  }

  getScenarioExecutedForEntity(anEut: any, attribute: any) {
    return this.getScenarioExecutedForEntityRunInfo(anEut.eID, attribute);
  }

  getScenarioPassedForEntity(anEut: any, attribute: any) {
    return this.getScenarioPassedForEntityRunInfo(anEut.eID, attribute);
  }

  getTotalForAnAttribute(attribute: any, dashboard: any) {
    // model.runModel
    var count: any;
    switch (dashboard) {
      case 'testCaseQuality':
        count = this.getTotalScenarioForAnAttribute(attribute.symbol);
        return count;
        break;
      case 'testExecutionQuality':
        count = this.getTotalExecutedPercentForAnAttribute(attribute.symbol);
        return count;
        break;
      case 'cleanlinessDegree':
        count = this.getTotalPassedPercentForAnAttribute(attribute.symbol);
        return count;
        break;
      default:
        return; //// added to avoid error
        break;
    }
  }

  getTotalScenarioForAnAttribute(attribute: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = 0;
    var negative: any = 0;
    if (this.model.scenarios) {
      if (this.model.scenarios.length > 1) {
        for (var i = 0; i < this.model.scenarios.length; i++) {
          if (
            this.model.scenarios[i].cr == '+' &&
            this.model.scenarios[i].tID == attribute &&
            this.model.scenarios[i].eType == this.eutType
          ) {
            positive++;
          }
          if (
            this.model.scenarios[i].cr == '-' &&
            this.model.scenarios[i].tID == attribute &&
            this.model.scenarios[i].eType == this.eutType
          ) {
            negative++;
          }
        }
      }
    }

    count.total = positive + negative;
    count.positive = positive;
    count.negative = negative;
    return count;
  }
  getTotalExecutedPercentForAnAttribute(attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAttribute(attribute);
    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = Math.round((executed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getTotalPassedPercentForAnAttribute(attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAttribute(attribute);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = Math.round((passed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }
  getScenariosForAttribute(attribute: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    var positive: any = [];
    var negative: any = [];
    var total: any = [];
    if (this.model.scenarios) {
      for (var i = 0; i < this.model.scenarios.length; i++) {
        if (
          this.model.scenarios[i].cr == '+' &&
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          positive.push(this.model.scenarios[i]);
        }
        if (
          this.model.scenarios[i].cr == '-' &&
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          negative.push(this.model.scenarios[i]);
        }
        if (
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          total.push(this.model.scenarios[i]);
        }
      }
    }
    scenario.positive = positive;
    scenario.negative = negative;
    scenario.total = total;
    return scenario;
  }
  //// model fn close

  ///// controller fn open

  //load the persona map according to the shifted tab
  // //set the eut type and reset the value of start
  setEUTtypeChosen(eutChosen: any) {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.model.eutType = eutChosen;
    this.model.startAt = 0;

    this.allItems = this.eutCollection[eutChosen];
    this.setPage(1);

    this.loadDashboards();
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  // //when select all is checked
  // //empty my ids from delselected id list
  // // and change the value of check in the eid list also
  toggleAllDeselect(checkVal: any) {
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        this.model.deSelectCollection[this.model.eutType].splice(eID, 1);
      } else {
        var isPresent = this.model.deSelectCollection[
          this.model.eutType
        ].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        if (isPresent == -1) {
          this.model.deSelectCollection[this.model.eutType].push(
            this.eutCollection[this.model.eutType][i].eID
          );
        }
      }
    }
    this.loadDashboardsUI();
  }

  toggleSelection(eID: any) {
    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == eID
    );
    // Is currently selected
    if (isPresent > -1) {
      this.model.deSelectCollection[this.model.eutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.deSelectCollection[this.model.eutType].push(eID);
    }
    this.loadDashboardsUI();
  }

  nextPage() {
    //finding start of list
    var startPosition = this.model.startAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if (this.eutCollection[this.model.eutType].length > startPosition) {
      this.model.startAt = startPosition;
      this.loadDashboardsUI();
    }
    this.isUpDownValid();
  }

  previousPage() {
    var startPosition = this.model.startAt - this.model.listLength;
    if (startPosition >= 0) {
      this.model.startAt = startPosition;
      this.loadDashboardsUI();
    }
    this.isUpDownValid();
  }

  firstPage() {
    this.model.startAt = 0;
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  lastPage() {
    this.model.startAt =
      this.eutCollection[this.model.eutType].length -
      (this.eutCollection[this.model.eutType].length % this.model.listLength);
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  isUpDownValid() {
    this.disableDown =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? true
        : false;
    this.disableUp = this.model.startAt - 1 >= 0 ? true : false;
  }



  isChecked(ID: any) {
    var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == ID
    );
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }

  isAllSelected() {
    var count = 0;
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      var isPresent = this.model.deSelectCollection[
        this.model.eutType
      ].findIndex(
        (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
      );
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.startAt;
    if (count == 0) {
      return true;
    } else if (count == noOfRows || count < noOfRows) {
      return false;
    } else {
      return; //// added to avoid error
    }
  }

  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  entityExistsCheck(eType: any) {
    var entities: any = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  //// controller fn close

  getScenarioTotalForEntityCheck(eID: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '+'
    );
    var negative: any = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '-'
    );
    count.total = positive.length + negative.length;
    count.positive = positive.length;
    count.negative = negative.length;
    return count;
  }

  getScenarioCountForEntityCheck(eID: any, attribute: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '+' && scenario.tID == attribute
    );
    var negative: any = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '-' && scenario.tID == attribute
    );
    count.total = positive.length + negative.length;
    count.positive = positive.length;
    count.negative = negative.length;
    return count;
  }

  getScenarioTotalForEntityCheckRunInfo(eID: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAnEntityRunInfo(eID);
    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = Math.round((executed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenariosForAnEntityRunInfo(eID: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    scenario.positive = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '+'
    );
    scenario.negative = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '-'
    );
    scenario.total = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID
    );
    return scenario;
  }

  getScenarioPassedTotalForEntityRunInfo(eID: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAnEntityRunInfo(eID);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = Math.round((passed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenarioExecutedForEntityRunInfo(anEut: any, attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForEntityRunInfo(anEut, attribute);

    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = Math.round((executed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenariosForEntityRunInfo(eID: any, attribute: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    scenario.positive = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '+' && scenario.tID == attribute
    );
    scenario.negative = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '-' && scenario.tID == attribute
    );
    scenario.total = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.tID == attribute
    );
    return scenario;
  }

  getScenarioPassedForEntityRunInfo(anEut: any, attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForEntityRunInfo(anEut, attribute);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = Math.round((passed.total / scenarios.total.length) * 100);
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getVideoURL(urlName: any) {
    console.log('urlName db', urlName);
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }
}
